import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Event } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeEvent(event: Boundaries["removeEvent"]["request"]): void;
}

function useRemoveEvent(event: Identifiable<Event>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveEventRequestPending(event),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveEventRequestSuccess(event),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveEventRequestFailure(event),
    ),
    removeEvent: core.removeEvent,
  };
}

export { useRemoveEvent };
